<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
			<user-avatar small/>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>{{ profile.name }}</strong>
    </CDropdownHeader>
    <CDropdownItem @click="onProfile">
      <CIcon name="cil-user" /> Up. račun
    </CDropdownItem>
    <CDropdownItem @click="onSettings">
      <CIcon name="cil-settings" /> Nastavitve
    </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem @click="onLogout">
      <CIcon name="cil-lock-locked" /> Odjava
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { 
  USER_SP_ORDERS_BRANDS_FILTER,
  USER_SP_ORDERS_DEPARTMENT_FILTER,
  USER_SP_ORDERS_LOCATION_FILTER,
  USER_SP_ORDERS_STATUS_FILTER,
  USER_SP_ORDERS_SORTING
} from "@/store/actions/spOrders";
import { USER_REPLACEMENT_VEHICLES_DEPARTMENT_FILTER } from "@/store/actions/replacementVehicles";
import { 
  VEHICLE_BRANDS_LIST_ALL_RESET
} from "@/store/actions/vehicleBrands";
import UserAvatar from '@/views/components/UserAvatar';
import settings from '@/settings.js';

export default {
  name: 'TheHeaderDropdownAccnt',
	components: {
		'user-avatar': UserAvatar
	},
  data () {
    return { 
      itemsCount: 42,
      settings
    }
  },
  computed: {
    profile() {
      return this.$store.getters.getProfile
    }
  },
  methods: {
    onProfile: function() {
      this.$router.push('/entities/users/profile');
    },
    onSettings: function() {
      this.$router.push('/entities/users/settings');
    },
    onLogout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$store.dispatch(USER_SP_ORDERS_BRANDS_FILTER, null)
            .then((responseData) => {
            })
            .catch(error => {
                console.error(error);
        });
        this.$store.dispatch(USER_SP_ORDERS_DEPARTMENT_FILTER, null)
            .then((responseData) => {
            })
            .catch(error => {
                console.error(error);
        });
        this.settings.spOrderDepartmentOptions.forEach(departmentOption => {
					departmentOption.active = false;
				});
        this.$store.dispatch(USER_SP_ORDERS_LOCATION_FILTER, null)
            .then((responseData) => {
            })
            .catch(error => {
                console.error(error);
        });
        this.settings.spOrderLocationOptions.forEach(option => {
					option.active = false;
				});
        this.$store.dispatch(USER_SP_ORDERS_STATUS_FILTER, null)
            .then((responseData) => {
            })
            .catch(error => {
                console.error(error);
        });
        this.settings.spOrderItemsStatusOptions.forEach(option => {
					option.active = false;
				});
        this.$store.dispatch(USER_SP_ORDERS_SORTING, null)
            .then((responseData) => {
            })
            .catch(error => {
                console.error(error);
        });
        this.$store.dispatch(VEHICLE_BRANDS_LIST_ALL_RESET)
            .then((responseData) => {
            })
            .catch(error => {
                console.error(error);
        });
        this.$store.dispatch(USER_REPLACEMENT_VEHICLES_DEPARTMENT_FILTER, null)
            .then((responseData) => {
            })
            .catch(error => {
                console.error(error);
        });
        this.settings.replacementVehicleDepartmentOptions.forEach(departmentOption => {
          departmentOption.active = false;
        });
        this.$router.push('/login');
      });
    }
  },
  created: function () {
    console.log('Header permissions', this.profile.permissions);
  }
}
</script>

<style scoped>
</style>